import type { RouteDefinition } from "../route-definition.ts";

export const adminPersonalRoutes = {
  "admin.meSection": {
    path: "/admin/me/:section",
    scope: "static",
    bucket: "admin",
    entry: "direct",
    disposition: "resolver",
  },
  "admin.me": {
    path: "/admin/me",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "resolver",
  },
  "admin.meDashboard": {
    path: "/admin/me/dashboard",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "resolver",
  },
  "admin.meLeagues": {
    path: "/admin/me/leagues",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "resolver",
  },
  "admin.meCoworlds": {
    path: "/admin/me/coworlds",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "resolver",
  },
  "admin.meExperienceRequests": {
    path: "/admin/me/xp-requests",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "resolver",
  },
  "admin.meProfile": {
    path: "/admin/me/profile",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "resolver",
  },
  "admin.mePolicies": {
    path: "/admin/me/policies",
    scope: "static",
    bucket: "admin",
    entry: "direct",
    disposition: "resolver",
  },
  "admin.meControls": {
    path: "/admin/me/controls",
    scope: "static",
    bucket: "admin",
    entry: "direct",
    disposition: "resolver",
  },
} as const satisfies Record<string, RouteDefinition>;
